import React, { useEffect, useState } from 'react'
import { sitePolicy } from '../../asiosConfig';
import facebookIcon from "../../images/facebookIcon.png";
import twitterIcon from "../../images/twitterIcon.png";
import instagramIcon from "../../images/instagramIcon.png";
function UserFooter() {
    const [footer, setFooter] = useState({});
    useEffect(() => {
        const fetchFooter = async () => {
            try {
                const response = await sitePolicy();
                if (response.status === 200 || response.status === 201) {
                    setFooter(response.data.data);
                }
            } catch (error) {
                console.log("Something went wrong");

            }
        }
        fetchFooter();
    }, []);
    return (
        <div className='footerEnd text-center mt-4 fixed-bottom lastF '>
            {/* fixed-bottom lastF */}
            <div className="container">
                <div className="row justify-content-between align-items-between">
                    <div className="col-lg-4 col-md-4 col-sm-12">
                        <div className="endSec">
                            <a href={footer?.fb_link} target="_blank" rel="noopener noreferrer">
                                <img src={facebookIcon} alt="facebook img" />
                            </a>&nbsp;
                            <a href={footer?.twitter_link} target="_blank" rel="noopener noreferrer">
                                <img src={twitterIcon} alt="twitter img" />
                            </a>&nbsp;
                            <a href={footer?.insta_link} target="_blank" rel="noopener noreferrer">
                                <img src={instagramIcon} alt="instagram img" />
                            </a>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-4 col-sm-12">
                        <div className="endSec">
                            <p className="copyrightTxt" style={{ whiteSpace: "nowrap" }}>{footer?.footer_txt}</p>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-4 col-sm-12">
                        <div className="endSec">
                            <p className="copyrightTxt"> <img src="images/mobileIcon.png" />{footer?.phoneNumber}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default UserFooter
